import * as React from 'react';

export default function usePersistentState<T>(initialValue: T, key: string): [T, (newValue: T) => void] {
    const [currentValue, setCurrentValue] = React.useState(() => {
        const storedValue = localStorage.getItem('salesmaster.' + key);
        if (storedValue) {
            return JSON.parse(storedValue);
        }

        return initialValue;
    });

    const setStoredValue = React.useCallback(
        (newValue: T) => {
            localStorage.setItem('salesmaster.' + key, JSON.stringify(newValue));
            setCurrentValue(newValue);
        },
        [key],
    );

    return [currentValue, setStoredValue];
}
